import React from 'react';

import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';
import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';

import * as S from './Loading.styles';

export const Loading = () => {
  return (
    <PageContent>
      <S.PageHeader>
        <S.Title />
        <S.Description />
      </S.PageHeader>
      <S.Content>
        <S.ContentHeader>
          <S.Button />
          <S.Button />
        </S.ContentHeader>
        <FormWrapper>
          {Array.from({ length: 14 }).map((_, index) => {
            return <S.Input key={`input-skeleton-${index}`} />;
          })}
        </FormWrapper>
      </S.Content>
    </PageContent>
  );
};
